// imports
import Vue from "vue";
import Vuex from "vuex";
import loader from "@/store/modules/loader";
import auth_user from "@/store/modules/auth_user";
import project from "@/store/modules/project";
import member from "@/store/modules/member";
import timer from "@/store/modules/timer";
import timesheet from "@/store/modules/timesheet";
import inner_card from "./modules/inner_card";
import createPersistedState from "vuex-persistedstate";
import {clearStaleTimerFromLocalStorage} from "@/utils/clearStaleDevPersistence";

clearStaleTimerFromLocalStorage();

// https://blog.sqreen.com/authentication-best-practices-vue/
// https://medium.com/@maciej.lisowski.elk/vue-vuex-store-short-tutorial-for-beginners-1befd8697654
// load vuex
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    loader,
    auth_user,
    project,
    member,
    timesheet,
    timer,
    inner_card,
  },
  strict: debug,
  // Never persist timer — stale running clock / active row caused play to zero hours.
  plugins: [
    createPersistedState({
      paths: ["auth_user"],
    }),
  ],
});

export default store;
